// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"201005d4","312":"2b562af3","403":"d9ef2f81","629":"a6fc9f5f","842":"1fe2f83c","869":"56df4853"}[chunkId] + ".chunk.js";
};